export enum CourseType {
  ElearningCourse = 'ELEARNING_COURSE',
  StandardCourse = 'STANDARD_COURSE',
  CourseBundle = 'COURSE_BUNDLE',
}
